import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SPA olduğu için sayfa başına <title>/description/canonical/OG'yi JS ile günceller.
// Googlebot JS render ettiği için bunu görür; sosyal önizleme (Discord/Twitter)
// için statik index.html'deki OG etiketleri yeterli (ana sayfa odaklı).
const SITE = 'https://vokelle.com';
const DEFAULT_TITLE = 'Vokelle — Private Server İzleme & Reklam Ölçümü';
const DEFAULT_DESC =
  "Private server'ınızın ekonomisini ve oyuncu aktivitesini 7/24 izleyin, anomalileri erkenden yakalayın. Yayıncılar için ücretsiz reklam tıklama ölçümü.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function Seo({ title, description, noindex = false }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = title ? `${title} — Vokelle` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = SITE + (pathname === '/' ? '/' : pathname);

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertLink('canonical', url);
  }, [title, description, noindex, pathname]);

  return null;
}
